import { comparisonFeatures } from "@/mocks/content";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Comparison
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Vigorbuy Spreadsheet vs Manual Search
          </h2>
          <p className="text-foreground-600 mt-3 max-w-xl mx-auto text-sm md:text-base">
            See why thousands of users choose the Vigorbuy Spreadsheet over manually searching for products.
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/60">
          <div className="grid grid-cols-3 items-center px-5 py-4 border-b border-background-200/60 bg-background-200/50">
            <span className="text-sm font-semibold text-foreground-950">Feature</span>
            <span className="text-sm font-semibold text-accent-600 text-center">Vigorbuy Spreadsheet</span>
            <span className="text-sm font-semibold text-foreground-500 text-center">Manual Search</span>
          </div>

          {comparisonFeatures.map((row, idx) => (
            <div
              key={idx}
              className={`grid grid-cols-3 items-center px-5 py-4 ${
                idx < comparisonFeatures.length - 1 ? "border-b border-background-200/40" : ""
              }`}
            >
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground-800">{row.feature}</span>
              </div>
              <div className="text-center flex items-center justify-center gap-2">
                <i className={`${row.spreadsheetIcon} text-accent-500 text-sm w-4 h-4 flex items-center justify-center`}></i>
                <span className="text-sm text-accent-700 font-medium">{row.spreadsheet}</span>
              </div>
              <div className="text-center flex items-center justify-center gap-2">
                <i className={`${row.manualIcon} text-foreground-400 text-sm w-4 h-4 flex items-center justify-center`}></i>
                <span className="text-sm text-foreground-500">{row.manual}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Try the Vigorbuy Spreadsheet Now
            <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}